import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { FaArrowLeft, FaClock, FaCheckCircle } from "react-icons/fa";
import { FaCodeMerge } from "react-icons/fa6";
import { Spinner } from "react-bootstrap";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { CustomTooltip } from "../../components/CustomTooltip";
import { FaInfo } from "react-icons/fa";
import {
  getSessionDetailsApi,
  getSessionInfoApi,
  mergeScanApi,
} from "../../services/AuditService";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import { toast } from "react-toastify";
import { SearchDepartmentBySessionIdApi } from "../../services/SearchService";
import { format } from "date-fns";
import { IoIosWarning } from "react-icons/io";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { TbReportSearch } from "react-icons/tb";
import { useSelector } from "react-redux";
import { OnlyAdmin } from "../../router/permission";

const StatusBadge = ({ status }) => {
  const badgeClass = `rounded-pill badge text-bg-${
    status ? "success-soft" : "danger-soft"
  }`;
  const icon = status ? (
    <FaCheckCircle className="me-1" />
  ) : (
    <FaClock className="me-1" />
  );

  return (
    <span className={badgeClass}>
      {icon}
      {status ? "Completed" : "In Complete"}
    </span>
  );
};
const statusOptions = [
  { label: "Completed", value: "true" },
  { label: "Incomplete", value: "false" },
];
const SessionDetails = () => {
  const role = useSelector((state) => state.auth.user.role || "user");
  const { id } = useParams();
  const [sessionData, setSessionData] = useState(null);
  const [areaData, setAreaData] = useState([]);
  const [areaLoading, setAreaLoading] = useState(false);
  const [areaError, setAreaError] = useState("");
  const [total, setTotal] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [departmentOption, setdepartmentOption] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [mergeModal, setMergeModal] = useState(false);
  const [mergeLoading, setMergeLoading] = useState(false);
  const [param, setParam] = useState({
    query: "",
    page: "1",
    page_size: "10",
    is_completed: "", // Changed from 'status' to 'is_completed'
    department: "",
  });

  const handleToggleMergeModal = () => {
    setMergeModal(!mergeModal);
  };
  const getDepartment = () => {
    SearchDepartmentBySessionIdApi(id)
      .then((res) => {
        setdepartmentOption(res?.data || []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  const getSessionInfo = () => {
    getSessionInfoApi(id)
      .then((res) => {
        setSessionData(res?.data || {});
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  const getData = () => {
    setAreaLoading(true);
    getSessionDetailsApi(id, param)
      .then((res) => {
        setAreaError("");
        setAreaData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setAreaError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setAreaLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, [param]);

  useEffect(() => {
    getDepartment();
    getSessionInfo();
  }, []);

  useEffect(() => {
    const dept = selectedDepartment?.value || "";
    const stat = selectedStatus?.value || "";

    setParam((prev) => ({
      ...prev,
      department: dept,
      is_completed: stat,
      page: "1",
    }));
  }, [selectedDepartment, selectedStatus]);
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: "1",
    }));
  };

  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  const doMerge = () => {
    setMergeLoading(true);
    mergeScanApi(id)
      .then((res) => {
        toast.success("Merged Completed");
        handleToggleMergeModal();
        getSessionInfo();
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setMergeLoading(false);
      });
  };
  return (
    <>
      <div className="card p-3">
        <div className="d-flex justify-content-between flex-wrap">
          <div className="d-flex gap-2">
            <Link
              to="/auditsession"
              className="btn rounded-1 py-2 stylish-transparent-btn align-self-center"
            >
              <FaArrowLeft />
            </Link>
            <div className="d-flex flex-column">
              <div>
                <h5>Session:{sessionData?.session_name || "N/A"}</h5>
              </div>
              <div>
                <span
                  className="text-dark fw-medium"
                  style={{ fontSize: "0.85rem" }}
                >
                  {sessionData?.start_date
                    ? format(sessionData?.start_date, "dd MMM yyyy")
                    : "-"}
                  {sessionData?.end_date
                    ? ` to ${format(sessionData?.end_date, "dd MMM yyyy")}`
                    : ""}
                </span>
              </div>
            </div>
          </div>
          <div className="d-flex gap-2">
            {sessionData?.is_merged ? (
              <Link
                to={`/final-audit/${id}`}
                className="btn stylish-transparent-btn"
              >
                <TbReportSearch className="me-1" />
                Scan Report
              </Link>
            ) : (
              OnlyAdmin.includes(role) && (
                <button
                  className="btn btn-primary align-self-center"
                  onClick={handleToggleMergeModal}
                >
                  <FaCodeMerge className="me-1" />
                  Merge
                </button>
              )
            )}
          </div>
        </div>
        <div className="mt-3 mb-1 row g-2">
          <div className="col-6 col-md-4 col-lg-2">
            <div className="text-center">
              <span
                className="text-dark fw-medium"
                style={{ fontSize: "0.9rem" }}
              >
                Total Auditors
              </span>
              <br />
              <span className="text-darker fw-medium">
                {sessionData?.total_auditors || 0}
              </span>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-2">
            <div className="text-center">
              <span
                className="text-dark fw-medium"
                style={{ fontSize: "0.9rem" }}
              >
                Total Areas
              </span>
              <br />
              <span className="text-darker fw-medium">
                {sessionData?.total_areas || 0}
              </span>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-2">
            <div className="text-center">
              <span
                className="text-dark fw-medium"
                style={{ fontSize: "0.9rem" }}
              >
                Total Assets
              </span>
              <br />
              <span className="text-darker fw-medium">
                {sessionData?.total_assets || 0}
              </span>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-2">
            <div className="text-center">
              <span
                className="text-dark fw-medium"
                style={{ fontSize: "0.9rem" }}
              >
                Total Scanned
              </span>
              <br />
              <span className="text-darker fw-medium">
                {sessionData?.total_scanned || 0}
              </span>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-2">
            <div className="text-center">
              <span
                className="text-dark fw-medium"
                style={{ fontSize: "0.9rem" }}
              >
                Completion
              </span>
              <br />
              <span className="text-darker fw-medium">
                {sessionData?.completion_percentage || 0}%
              </span>
            </div>
          </div>
          <div className="col-6 col-md-4 col-lg-2">
            <div className="text-center">
              <span
                className="text-dark fw-medium"
                style={{ fontSize: "0.9rem" }}
              >
                Status
              </span>
              <br />
              <span className="text-darker fw-medium">
                {sessionData?.overall_status || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="card mt-2">
        <div className="p-4 d-flex flex-column flex-md-row justify-content-between gap-1">
          <div className="flex-fill flex-md-grow-0">
            <DebounceSmallSearchInput handleSearchChange={handleSearchChange} />
          </div>
          <div className="d-flex flex-wrap gap-2">
            <GlobalSearchableDropdown
              options={departmentOption}
              selected={selectedDepartment}
              onSelect={(item) => setSelectedDepartment(item)}
              placeholder="Department"
            />
            <GlobalSearchableDropdown
              options={statusOptions}
              selected={selectedStatus}
              onSelect={(item) => setSelectedStatus(item)}
              placeholder="Status"
              isClearable={true} // This allows clearing the selection
            />
          </div>
        </div>
        <div>
          {areaLoading ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : areaError ? (
            <div className="text-center text-danger my-4">{areaError}</div>
          ) : areaData && areaData.length > 0 ? (
            <div className="table-responsive">
              <table className="table fs-6 mb-0 align-middle">
                <thead className="table-light custom-thead">
                  <tr>
                    <th>Area</th>
                    <th>Department</th>
                    <th>Auditor</th>
                    <th>Total Asset</th>
                    <th>Scanned Asset</th>
                    <th>Completion Percentage</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {areaData?.map((item) => {
                    return (
                      <tr>
                        <td>
                          <Link
                            to={`/area-audit/${id}/${item?.area_id}`}
                            className="fw-medium text-primary"
                          >
                            {item?.area_name || "-"}
                          </Link>
                        </td>
                        <td>{item?.department || "-"}</td>
                        <td>{item?.auditor_name || "-"}</td>
                        <td>{item?.total_assets || 0}</td>
                        <td>
                          <div className="d-flex gap-2">
                            <span>
                              {item?.scanned_assets || 0}
                              <CustomTooltip
                                title={
                                  <div>
                                    <div>
                                      <strong>Verified:</strong>{" "}
                                      {item?.status_counts?.verified || 0}
                                    </div>
                                    <div>
                                      <strong>Missing:</strong>{" "}
                                      {item?.status_counts?.missing || 0}
                                    </div>
                                    <div>
                                      <strong>Misplaced:</strong>{" "}
                                      {item?.status_counts?.misplaced || 0}
                                    </div>
                                    <div>
                                      <strong>Unassigned:</strong>{" "}
                                      {item?.status_counts?.unassigned || 0}
                                    </div>
                                  </div>
                                }
                                placement="right"
                              >
                                <span
                                  className="rounded-1 ms-1 btn btn-sm btn-outline-light"
                                  style={{
                                    cursor: "pointer",
                                    padding: "0.2rem 0.2rem",
                                  }}
                                >
                                  <FaInfo size={9} className="text-dark" />
                                </span>
                              </CustomTooltip>
                            </span>
                          </div>
                        </td>
                        <td>{item?.scan_progress || 0}%</td>
                        <td>
                          <StatusBadge status={item?.is_scanning_completed} />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center my-4">
              <span>No data found</span>
            </div>
          )}

          {!areaLoading && areaData?.length > 0 && (
            <div className="p-4">
              <Pagination
                currentPage={param.page}
                recordsPage={param.page_size}
                dataLength={total}
                handlePagination={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>

      <Dialog
        open={mergeModal}
        onClose={handleToggleMergeModal}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "error.main",
            fontWeight: 600,
          }}
        >
          <IoIosWarning className="text-danger" />
          Finalize & Merge Audit
        </DialogTitle>

        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            You're about to{" "}
            <strong>complete and merge this audit session</strong>.
            <br />
            <br />
            Please ensure that{" "}
            <strong>all assigned areas have been scanned</strong> and{" "}
            <strong>all assets within those areas are verified</strong> by the
            auditors.
            <br />
            <br />
            Once merged,{" "}
            <span style={{ color: "#d32f2f", fontWeight: 500 }}>
              no further changes or rescans will be allowed.
            </span>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Proceed only if all scanning is complete and accurate.
          </Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleToggleMergeModal}
            variant="outlined"
            color="inherit"
            disabled={mergeLoading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            disabled={mergeLoading}
            sx={{ minWidth: 110 }}
            onClick={doMerge}
          >
            {mergeLoading && (
              <Spinner animation="border" size="sm" className="me-1" />
            )}
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SessionDetails;
